import styled from 'styled-components'

export const ContainerBox = styled.div`
	width: 100%;
	display: flex;
	z-index: 200;
	box-sizing: border-box;
	flex-shrink: 0;
	flex-direction: column;
	overflow: hidden;
`

export const ImageBox = styled.div`
	background-image: url(${({ url }) => url});
	background-repeat: no-repeat;
	background-size: cover;
	background-color: #e3f8f4;
	background-position: center;
	height: 350px;
	width: 100%;
	position: relative;
`

export const TitleBox = styled.div`
	font-style: normal;
	font-weight: 700;
	font-size: 32px;
	line-height: 40px;
	color: #00aae5;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	height: 100%;
	p {
		margin: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px 70px;
		background: rgba(255, 255, 255, 0.9);
		backdrop-filter: blur(17px);
		border-radius: 24px 24px 0px 0px;
	}
`

export const WorkerBox = styled.div`
	font-style: normal;
	box-sizing: border-box;
	gap: 32px;
	isolation: isolate;
	background: #ffffff;
	order: 0;
	width: 288px;
	border-radius: 20px 20px 0 0;
	opacity: 0.9599999785423279;
	margin-top: 62px;
	margin-left: 40px;
`
